<template>
  <div id="stock-image">
    <vs-popup ref="popup-selector" class="chat-upload-image-popup"  title="Atenção!" :active.sync="activeSelector" v-on:close="closeSelector">
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" class="mb-5 text-center">
        <div>
          <p v-if="!isWebp">Selecione a forma que será <b>encaminhada</b> a imagem</p>
          <p v-else>Imagens com extensão <b>.webp</b> só podem ser enviados como figurinhas.</p>
        </div>
      </vs-col>

      <footer>
        <div class="w-full d-flex " style="justify-content: center">
          <vs-button
            color="primary"
            class="mr-2"
            icon-pack="feather"
            icon="icon-image"
            v-if="!isWebp"
            @click.prevent="sendImage()"
          >
            <span>Imagem</span>
          </vs-button>

          <vs-button
            color="primary"
            class="mr-2"
            icon-pack="feather"
            icon="icon-compass"
            @click.prevent="sendSticker()"
          >
            <span>Figurinha</span>
          </vs-button>
        </div>
      </footer>
    </vs-popup>

    <vs-popup ref="popup-cropper" class="chat-upload-image-popup" title="Adicionar imagem" :active.sync="activeCrop" v-on:close="closeCrop">
      <image-cropper 
        :src="imageUrl" 
        @on-cropp-image="imageCropped"
      ></image-cropper>
    </vs-popup>

    <div id="image">
      <div id="image-uploader" class="con-img-upload">
        <upload
          automatic
          fileName="file"
          ref="uploadComponent"
          text="Adicionar Imagem"
          accept=".jpg, .jpeg, .gif, .jfif, .mpeg, .png, .web, .webp"
          :maxSize="3"
          :limit="1"
          :single-upload="true"
          :action="uploadApiUrl"
          :headers="{ Authorization: 'Bearer ' + bearer }"
          @on-success="successUploadImage"
          @on-error="errorUploadImage"
          @on-upload-start="imageUrl = null"
        />
        
        <div
          v-for="img in images"
          :key="img.url"
          class="img-upload flex-row"
        >
          <button
            class="btn-x-file"
            type="button">
            <i
              translate="no"
              @click="removeDialog(img)"
              class="material-icons notranslate">
              clear
            </i>
          </button>

          <img
            alt="gallery"
            class="object-cover object-center"
            :style="{ maxWidth: '100%', maxHeight: '100%' }"
            :src="img.url"
            @touchend="sendDialog(img)"
            @click="sendDialog(img)"
          />
      </div>
    </div>
  </div>
</div>
</template>

<script>

import moduleStockImages from '@/store/stockImages/moduleStockImages'
import ImageCropper from '@/components/image-cropper/ImageCropper'
import Upload from '@/components/upload/Upload'

export default {
  name: "ViewStockImages",
  props: {
    images: {
      default: null,
    },
  },
  components: {
    Upload,
    ImageCropper
  },
  data() {
    return {
      imageSelected: {},
      imageCaption: '',
      imageUrl: null,
      activeSelector:false,
      activeCrop: false,
    }
  },
  computed:{
    uploadApiUrl() {
      return localStorage.getItem("baseUrl") + "/api/file/upload";
    },
    bearer() {
      return this.$store.state.auth.bearer;
    },
    isWebp(){
      if (this.imageSelected && this.imageSelected.url){
        return this.getExtension(this.imageSelected.url) === 'webp';
      }
      return false;
    }
  },
  methods: {
    sendImage() {
      this.closeSelector();
      this.$emit('on-send-image', 'image', this.imageSelected.url)
    },
    sendSticker() {
      this.closeSelector();
      this.$emit('on-send-sticker', 'sticker', this.imageSelected.url)
    },
    async fetchStockImage(){
      this.$store.dispatch('stockImages/fetch')
    },
    async addStockImage(){
      this.$store.dispatch('stockImages/add', {url: this.imageUrl, caption: this.imageCaption})
      this.imageUrl = null;
      this.imageCaption = '';
    },
    async removeStockImage(id){
      this.$store.dispatch('stockImages/remove', id).then(() => {
        this.$vs.notify({
          color: "success",
          title: "Imagem removida com sucesso!",
        });
      }) 
    },
    imageCropped(response) {
      this.imageUrl = response.data.fileUrl
      this.closeCrop()
      this.addStockImage();
    },
    successUploadImage(response) {
      this.imageUrl = response.data.fileUrl
      this.imageCaption = response.srcs[response.srcs.length - 1].name
        ? response.srcs[response.srcs.length - 1].name
        : ''

      this.$refs.uploadComponent.removeFile(null, true)
      const extension = this.getExtension(this.imageUrl)
      if (extension !== 'gif' && extension !== 'webp'){
        return this.activeCrop = true
      }

      this.addStockImage();
    },
    errorUploadImage(response) {
      this.$vs.notify({
        color: "danger",
        title: "Ocorreu um erro ao subir a imagem!",
        text: response.data.message,
      });
    }, 
    sendDialog(image){
      this.activeSelector = true
      this.imageSelected = image
    },
    removeDialog(image) {
      this.$vs.dialog({
        color: 'primary',
        title: `Atenção!`,
        text: 'Você deseja excluir a imagem?',
        accept: () => { this.removeStockImage(image.id) },
        acceptText: 'Sim',
      })
    },
    getExtension(text) {
      const split = text.split('?GoogleAccessId')[0].split('.')
      return split[split.length - 1]
    },
    closeSelector() {
      this.activeSelector = false
    },
    closeCrop() {
      this.activeCrop = false
    },
    closePopUps() {
      this.closeSelector();
      this.closeCrop();
    }
  },
  created() {
    this.$parent.$on('closeAllPopUps', this.closePopUps);
    if (!moduleStockImages.isRegistered) {
      this.$store.registerModule("stockImages", moduleStockImages);
      moduleStockImages.isRegistered = true;
    }
  },
  beforeDestroy() {
    this.$parent.$off('closeAllPopUps', this.closePopUps);
  }
}
</script>


<style lang="scss">
  #stock-image{
    flex-wrap: wrap;
    text-align: center;
    display: inline-flex;
    align-content: center;
    justify-content: center;

    .switch{
      border: 1px solid rgba(0, 0, 0, 0.2); 
      border-radius: 10px;
    }
  }

  #image-uploader {
    display: flex;
    flex-wrap: wrap;
    text-align: center;
    justify-content: center;

    .con-upload{
      width: auto;
      display: flex;
      text-align: center;
      justify-content: center;
    }

    .con-img-upload{
      display: contents !important;
      max-width: 17rem !important;
    }
  }
</style>
